import React, { useEffect, useState } from "react";
import api from "src/rest/api";
import { useOverlay } from "src/screens/checkout/OverlayContext";

const MigrationTerm: React.FC = () => {
  const [accepted, setAccepted] = useState(false);
  const [accepted2, setAccepted2] = useState(false);

  const over = useOverlay();

  useEffect(() => {
    if (window.location.pathname !== "/dash") {
      localStorage.removeItem("hasOldCustomerId");
      over.dismiss();
    }
  }, [window.location.pathname]);

  function migrateUser() {
    api.post("platform-term/accept").then((response) => {
      if (response.status === 200) {
        localStorage.removeItem("hasOldCustomerId");
        over.dismiss();
      }
    });
  }

  function closeOverlay() {
    over.dismiss();
  }

  return (
    <div className="relative mx-auto flex max-w-2xl flex-col items-center justify-center gap-4 rounded-md bg-white p-4">
      {/* Close button */}
      <button
        onClick={closeOverlay}
        type="button"
        aria-label="Fechar"
        className="absolute right-2 top-2 rounded p-1 transition hover:bg-zinc-100"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="5" y1="5" x2="15" y2="15" />
          <line x1="15" y1="5" x2="5" y2="15" />
        </svg>
      </button>

      <h2 className="text-xl font-bold">Termo de Migração de Cadastro</h2>
      <p className="text-center">
        Caro professor, seja bem-vindo à nova plataforma! Estamos migrando seu
        cadastro para proporcionar uma experiência ainda melhor. Por favor, leia
        atentamente as informações abaixo antes de prosseguir.
      </p>
      <div className="rounded-lg bg-zinc-150 p-2 text-sm">
        <p>
          Ao prosseguir, você confirma o cancelamento do seu cadastro anterior
          realizado na <strong>fithub.app.br</strong> e concorda com a migração
          dos seus dados para a <strong>hypefit.com.br</strong>.
        </p>
        <br />
        <p>
          Caso haja alguma assinatura ativa, o valor proporcional (pró-rata)
          referente à sua assinatura ativa na <strong>fithub.app.br</strong>{" "}
          será devolvido conforme as condições estabelecidas pela Stripe.
        </p>
        <br />
        <p>
          Para o pleno uso da plataforma, após a migração, será necessário criar
          uma nova assinatura, para que possa desfrutar de todas as funções da
          plataforma.{" "}
          <strong className="font-semibold text-zinc-500">
            Recomendamos que aproveite a ultima oportunidade de assinatura com
            desconto, exclusiva para você, testador BETA!
          </strong>
        </p>
      </div>

      <label className="flex cursor-pointer select-none items-start gap-2 text-xs">
        <input
          type="checkbox"
          checked={accepted}
          onChange={() => setAccepted(!accepted)}
          className="peer sr-only"
        />
        <span
          className={`mt-1 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded border-2 border-gray-300 bg-white transition-colors duration-150 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-focus:ring-2 peer-focus:ring-primary-400`}
        >
          {accepted && (
            <svg
              className="h-3 w-3 text-white"
              viewBox="0 0 12 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 6l2 2 4-4" />
            </svg>
          )}
        </span>
        <span className="leading-snug">
          Concordo com o termo de migração, o cancelamento do cadastro anterior
          e entendo que preciso criar uma nova assinatura para usar a nova
          plataforma.
        </span>
      </label>

      <label className="flex cursor-pointer select-none items-start gap-2 text-xs">
        <input
          type="checkbox"
          checked={accepted2}
          onChange={() => setAccepted2(!accepted2)}
          className="peer sr-only"
        />
        <span
          className={`mt-1 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded border-2 border-gray-300 bg-white transition-colors duration-150 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-focus:ring-2 peer-focus:ring-primary-400`}
        >
          {accepted2 && (
            <svg
              className="h-3 w-3 text-white"
              viewBox="0 0 12 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 6l2 2 4-4" />
            </svg>
          )}
        </span>
        <span className="leading-snug">
          Concordo que, valores proporcionais, referente à assinatura anterior,
          será reembolsada proporcionalmente, conforme as condições
          estabelecidas pela Stripe (5-10 dias úteis).
        </span>
      </label>

      <div>
        <button
          onClick={migrateUser}
          type="button"
          className="rounded bg-primary-600 px-4 py-2 text-sm text-white disabled:opacity-50"
          disabled={!accepted || !accepted2}
        >
          Aceitar
        </button>
      </div>
    </div>
  );
};

export default MigrationTerm;
